var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data?.iconUrl)?_c('img',{attrs:{"src":_vm.data?.iconUrl,"alt":_vm.data?.iconUrl,"width":_vm.data?.width,"height":_vm.data?.height}}):_c('img',{staticClass:"img-list",attrs:{"src":_vm.data?.iconUrls[0],"alt":_vm.data?.iconUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }